export default __webpack_public_path__ + "static/media/cameras.823a0d29.svg";